export default __webpack_public_path__ + "static/media/geen luiksluiting.jpg";